export default "__VITE_ASSET__CxaXdBt0__"